import React, { useEffect, useRef } from 'react';
import QRious from 'qrious';
import { resolveDisplayCode } from '../utils/redeemDisplayCode';

export function buildCouponQrValue(redeemToken) {
  return `SGLRT-CLAIM:${redeemToken || ''}`;
}

export default function CouponQrBlock({
  redeemToken,
  claimId,
  displayCode,
  px = (n) => n,
  size = 240,
  label = '兌換編號',
}) {
  const canvasRef = useRef(null);
  const code = resolveDisplayCode(claimId, displayCode);

  useEffect(() => {
    if (!canvasRef.current || !redeemToken) return;
    // eslint-disable-next-line no-new
    new QRious({
      element: canvasRef.current,
      value: buildCouponQrValue(redeemToken),
      size,
      background: '#ffffff',
      foreground: '#111111',
    });
  }, [redeemToken, size]);

  return (
    <div className="cqb-wrap">
      <div className="cqb-card">
        <canvas ref={canvasRef} className="cqb-canvas" />
      </div>
      {code ? (
        <div className="cqb-claim-id" style={{ fontSize: px(48) }}>
          {label} {code}
        </div>
      ) : null}
    </div>
  );
}
